<div class="p-6 space-y-4 md:space-y-6 sm:p-8">
  <div class="container flex flex-row items-center">
    <h1 class="text-xl font-bold">
      Actualizar Tasas
    </h1>
  </div>
  <form *ngIf="formCuenta" class="space-y-4 md:space-y-6" [formGroup]="formCuenta">
    <div class="grid grid-cols-2 gap-4">
      <mat-form-field appearance="outline" class="modern-field">
        <mat-label>Tasa CLP</mat-label>
        <input type="number" matInput formControlName="tasaCLP" step="0.1" [readonly]="true" class="readonly-input"/>
      </mat-form-field>
      <mat-form-field appearance="outline" class="modern-field">
        <mat-label>Porcentaje comisión</mat-label>
        <input type="number" matInput formControlName="porcentajeComision" step="0.1"/>
      </mat-form-field>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <mat-form-field appearance="outline" class="modern-field">
        <mat-label>Tasa {{ tipoTasa}}</mat-label>
        <input type="number" matInput formControlName="tasaCRXT" step="0.1"/>
      </mat-form-field>
    </div>
    <div class="container flex flex-col items-center">
      <button (click)="actualizarTasa()"
        class="w-1/2" [disabled]="formCuenta.invalid || formCuenta.hasError('outOfRange')"
        style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        Guardar
      </button>
    </div>
  </form>
</div>
